import { memo } from 'react'
import { classNames } from '@app/utils/classes'
import { FixedCopyRight } from '../fixed-copy-right'
import { Link } from '@app/components/stateless/typo/link'

import { Logo } from './logo'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { useAuthContext } from '@app/components/providers/auth'
import { twitterBuilder } from '@app/lib/twitter-builder'
import { FILTERED_MARKETING } from '@app/configs/app-config'

const aCss = 'hover:text-blue-800 dark:hover:text-blue-400'

// bottom navigation menu
const BottomMenuComponent = ({ active }: { active?: string }) => {
  const { t, lang } = useTranslation('common')
  const { account } = useAuthContext()

  const { authed, inited: loaded } = account ?? {}

  return (
    <nav className='px-4 py-8 md:py-12 gap-x-2 transition-transform block md:grid md:grid-cols-[2.5rem_1fr]'>
      <Link
        href={'/'}
        target={'_blank'}
        className={
          'inline-block transition transform hover:-translate-y-0.5 motion-reduce:transition-none motion-reduce:hover:transform-none'
        }
      >
        <Logo t={t} />
      </Link>
      <div className='space-y-1'>
        <div className='flex flex-wrap gap-x-2'>
          {authed ? (
            <Link
              href={`/settings`}
              className={classNames(
                aCss,
                active === 'settings' ? 'text-blue-700 dark:text-blue-600' : ''
              )}
            >
              {t('menu:settings')}
            </Link>
          ) : loaded ? null : (
            <div className='min-h-[30px] min-w-[66.25px] bg-gray-300 dark:bg-gray-800' />
          )}
          <Link
            href={`/api-info`}
            shouldPrefetch={false}
            className={classNames(
              aCss,
              active === 'api-info' ? 'text-blue-700 dark:text-blue-600' : ''
            )}
          >
            {t('api-info')}
          </Link>
          <Link
            href={`/visualizer`}
            shouldPrefetch={false}
            className={classNames(
              aCss,
              active === 'visualizer' ? 'text-blue-700 dark:text-blue-600' : ''
            )}
          >
            {t('data-parse:header')}
          </Link>
          <Link
            href={`/contact`}
            target={'_blank'}
            className={aCss}
            shouldPrefetch={false}
          >
            {t('support')}
          </Link>
          {FILTERED_MARKETING ? null : (
            <Link
              href={`/guides`}
              target={'_blank'}
              className={aCss}
              shouldPrefetch={false}
            >
              {t('guides')}
            </Link>
          )}

          <Link
            href={`/terms-of-service`}
            target={'_blank'}
            className={aCss}
            shouldPrefetch={false}
          >
            {t('legal')}
          </Link>
          <Link
            href={`/status`}
            target={'_blank'}
            className={aCss}
            shouldPrefetch={false}
          >
            {t('status')}
          </Link>
          {FILTERED_MARKETING ? null : (
            <Link
              href={`/roadmap`}
              target={'_blank'}
              className={aCss}
              shouldPrefetch={false}
            >
              {t('roadmap')}
            </Link>
          )}
          {authed ? (
            <Link href={`/logout`} className={aCss} shouldPrefetch={false}>
              {t('menu:logout')}
            </Link>
          ) : loaded ? null : (
            <div className='min-h-[30px] min-w-[57px] bg-gray-300 dark:bg-gray-800' />
          )}
        </div>
        <div className='flex gap-x-2 place-items-center pl-3 md:pl-0.5'>
          <FixedCopyRight />
          <Link
            target={'_blank'}
            href={`https://twitter.com/${twitterBuilder(lang)}`}
            shouldPrefetch={false}
            className={'hover:text-blue-600'}
          >
            <>
              <span className='sr-only'>
                {t('logo', { companyName: 'Twitter' })}
              </span>
              <svg
                fill='currentColor'
                height='14'
                width='14'
                viewBox='0 0 22 20'
              >
                <path d='M16.99 0H20.298L13.071 8.26L21.573 19.5H14.916L9.702 12.683L3.736 19.5H0.426L8.156 10.665L0 0H6.826L11.539 6.231L16.99 0ZM15.829 17.52H17.662L5.83 1.876H3.863L15.829 17.52Z'></path>
              </svg>
            </>
          </Link>
        </div>
      </div>
    </nav>
  )
}

export const BottomMenu = memo(BottomMenuComponent)
